import { render, staticRenderFns } from "./directDebitLegals.vue?vue&type=template&id=c8358662&"
import script from "./directDebitLegals.vue?vue&type=script&lang=js&"
export * from "./directDebitLegals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports